import { __decorate } from "tslib";
import { injectable } from "inversify";
let BaseTrackingEventHandler = class BaseTrackingEventHandler {
};
BaseTrackingEventHandler = __decorate([
    injectable()
], BaseTrackingEventHandler);
export { BaseTrackingEventHandler };
//# sourceMappingURL=BaseTrackingEventHandler.js.map